module.exports = __webpack_public_path__ + "img/img_404.99401d84.png";